:root {
  /* Colors */
  --color-bittersweet: #fe7165;
  --color-viking-rgb: 122, 186, 217;
  --color-fountain-blue-rgb: 78, 163, 193;
  --color-mystic: #dde6ed;
  --color-athens-grey: #f7f8fa;
  --color-athens-grey-rgb: 247, 248, 250;
  --color-regent-gray: #7b8b97;
  --color-regent-gray-rgb: 126, 142, 159;
  --color-hint-of-red: #f7f5f4;
  --color-downy: #6fc6c6;
  --color-downy-rgb: 111, 198, 198;
  --color-atomic-tangerine: #ffaa6c;
  --color-salmon: #ff8075;
  --color-salmon-rgb: 255, 128, 117;

  --color-vivid-tangerine: #fe9f84;
  --color-light-slate-grey: #7e8e9f;
  --color-light-slate-grey-rgb: 126, 142, 159;
  --color-slate-grey: #6c808b;
  --color-slate-grey-rgb: 108, 128, 139;
  --color-sky-blue-rgb: 188, 218, 229;
  --color-ziggurat-rgb: 188, 218, 229;
  --color-porcelain-rgb: 226, 230, 233;
  --color-cornflower-rgb: 138, 201, 231;
  --color-fantasy: #fbf2f1;
  --color-powder-blue: #bedeea;
  --color-ziggurat: #82aaab;
  --color-gumbo-rgb: 130, 170, 171; /* #82aaab */
  --color-mabel: #c3dedf;
  --color-mabel-rgb: 195, 222, 223;
  --color-aqua-haze: #e5eef1;
  --color-neptune: #72bfbb;
  --color-black-haze: #fafbfb;
  --color-solitude: #e7ecf2;
  --color-solitude-rgb: 231, 236, 242;
  --color-solitude-white: #eff2f7;
  --color-solitude-white-rgb: 239, 242, 247;
  --color-peach-orange: #fdbd9a;
  --color-peach-orange-rgb: 253, 189, 154;
  --color-woodsmoke: #151d1d;
  --color-morning-glory-rgb: 149, 200, 218;
  --color-blue-bayoux: #526476;
  --color-blue-bayoux-rgb: 82, 100, 118;
  --color-shadow-green: #99bfc0;
  --color-shadow-green-rgb: 153, 191, 192;
  --color-error: #ff877d;

  --gradient-red: linear-gradient(236.34deg, #fe685b -25.2%, #ff8b81 39.5%);
  --gradient-sky: linear-gradient(167.66deg, #e2eff4 30.05%, #eee7e2 89.04%);
  --gradient-green: linear-gradient(92.31deg, #82c9b8 8.58%, #72bfbb 107.9%);
  --gradient-desert-storm-to-provincial-pink: linear-gradient(
    316.36deg,
    #ece9e6 0%,
    #fae5da 100%
  );
  --gradient-sky-blue-to-salmon: linear-gradient(
    170deg,
    rgba(188, 218, 229, 0.3) 42.69%,
    rgba(245, 203, 181, 0.3) 97.73%
  );
  --gradient-ziggurat-to-lola: linear-gradient(
    157.58deg,
    #bcdae5 7.79%,
    #bbaebf 98.76%
  );

  --color-dashboard-circle-background: linear-gradient(
    161.05deg,
    #bcdae5 25.42%,
    #f5cbb5 178.13%
  );

  --gradient-ziggurat-to-edgewater: linear-gradient(
    136.44deg,
    #bcdae5 8.84%,
    #cbe2da 95.88%
  );

  --gradient-ziggurat-to-pink: linear-gradient(
    136.43deg,
    #bcdae5 -105.47%,
    #f5cbb5 108.95%
  );

  --gradient-ziggurat-to-pink2: linear-gradient(
    133.76deg,
    #bcdae5 8.25%,
    #f5cbb5 243.89%
  );

  --color-dashboard-background: #f7f8fa;

  /* Sizes */
  --sidebar-width: 20rem;
  --content-max-width: 80rem;
}

html,
body,
#root {
  display: flex;
  flex: 1;
}

body {
  background-color: var(--color-semantic-surface-neutral20);
}

svg {
  outline: none;
}

#overlay-root {
  position: fixed;
  z-index: 1;
}

#primitives-root {
  position: fixed;
  z-index: 2;
}
